import { Injectable } from '@angular/core';
import { CookieOptions, CookieService as cs } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class CookieService {
  constructor(private cookieService: cs) {}

  getCookie = (cname: string): string => this.cookieService.get(cname);

  getDesSession = (): string => this.getCookie('des_session');

  getMarketsMock = (): string => this.getCookie('markets_mock');

  getLocale = (): string => this.getCookie('locale') || 'en_US';

  /**
   * Gets the locale cookie formatted for i18n
   */
  getI18NLocale = (): string => {
    const raw = this.getCookie('locale');
    return raw?.replace('_', '-').toLowerCase();
  };

  /**
   * Gets the brand value formatted for i18n
   */
  getI18NBrand = (): string => {
    const raw = this.getCookie('default_brand') || '';
    return raw.toUpperCase();
  };

  setCookie = (name: string, value: string, days?: number): void => {
    const cookieOpts: CookieOptions = {
      path: '/',
    };
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      cookieOpts.expires = date;
    }
    this.cookieService.set(name, value, cookieOpts);
  };

  deleteCookie = (name: string, path?: string, domain?: string): void => {
    if (this.getCookie(name)) {
      const cookieDomain = this.getCookie('domain_cookie');
      this.cookieService.delete(name, path ?? '/', domain ?? cookieDomain ?? '.calibrantenergy.net');
    }
  };
}
